import { useEffect, useState } from 'react';
import { SearchCodeModalForm } from 'src/components/common/form/search/SearchCodeModalForm';
import { SearchDateRangeForm } from 'src/components/common/form/search/SearchDateRangeForm';
import { SearchDropDownForm } from 'src/components/common/form/search/SearchDropDownForm';
import { SearchSectionDoubleForm } from 'src/components/common/form/search/SearchSectionDoubleForm';
import { useInfoFormEvents } from 'src/hooks/useInfoFormEvents';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import useUiuxStore from 'src/store/useUiuxStore';
import { InfoCodeSearchFieldConfig } from 'src/types/info-form';
import { defaultTQC2010_R01Filter, useTQC2010_R01Store } from './Store_TQC2010_R01';

export const SearchSection_TQC2010_R01 = () => {
	const { TQC2010_R01Filter, setTQC2010_R01Filter } = useTQC2010_R01Store();
	const { compCdList, workPlaceList, inspectionTypeList } = useCommonCodeStore();
	const { setCodeSearchModalProps } = useUiuxStore();

	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

	const handleWorkEmpFocusId = 'tqc2010_workEmp_search';

	// 검사구분: "전체" 옵션 없이 항상 값이 있어야 하므로, 목록이 로드되면 첫 항목을 기본 선택
	useEffect(() => {
		if (!TQC2010_R01Filter.inspectType && inspectionTypeList.length > 0) {
			setTQC2010_R01Filter({ inspectType: inspectionTypeList[0].minorCd });
		}
	}, [inspectionTypeList, TQC2010_R01Filter.inspectType, setTQC2010_R01Filter]);

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'workEmp',
			category: '작업자',
			focusId: handleWorkEmpFocusId,
			responseMapping: {
				empNo: 'workEmp',
				empNm: 'workEmpNm',
			},
			extraFilter: () => ({
				workEmp: TQC2010_R01Filter.workEmp || '',
				workEmpNm: TQC2010_R01Filter.workEmpNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: TQC2010_R01Filter,
		setEditData: setTQC2010_R01Filter,
		defaultData: defaultTQC2010_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'TQC2010_R01_search',
	});

	return (
		<SearchSectionDoubleForm>
			<SearchDropDownForm
				label="검사구분"
				value={TQC2010_R01Filter.inspectType}
				onChangeItem={(item) => setTQC2010_R01Filter({ inspectType: item?.minorCd || '' })}
				optionList={inspectionTypeList}
				initLabelLess
			/>
			<SearchDropDownForm
				label="사업장"
				value={TQC2010_R01Filter.compCd}
				onChangeItem={(item) => setTQC2010_R01Filter({ compCd: item?.compCd || '' })}
				optionList={compCdList}
			/>
			<SearchDateRangeForm
				label="생산일자"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={TQC2010_R01Filter.dateRange}
				setDateRange={(range) => setTQC2010_R01Filter({ dateRange: range })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			<SearchDropDownForm
				label="작업공정"
				value={TQC2010_R01Filter.workplaceCd}
				onChangeItem={(item) => setTQC2010_R01Filter({ workplaceCd: item?.workplaceCd || '' })}
				optionList={workPlaceList.filter((opt) => opt.compCd === TQC2010_R01Filter.compCd)}
				editable={TQC2010_R01Filter.compCd !== ''}
			/>
			<SearchCodeModalForm
				label="작업자"
				value={TQC2010_R01Filter.workEmp}
				valueLabel={TQC2010_R01Filter.workEmpNm}
				handleFoucsId={handleWorkEmpFocusId}
				onChange={getFieldHandlers('workEmp').onChange}
				onDoubleClick={getFieldHandlers('workEmp').onDoubleClick}
				onKeyDown={getFieldHandlers('workEmp').onEnterKeyDown}
			/>
		</SearchSectionDoubleForm>
	);
};
